/*
ALL RIGHTS RESERVED. The content of this document is protected by copyright and constitutes trade secrets.
The content hereof may also be protected by patents, trademarks, design rights and other intellectual property rights.
The rights contained herein are owned or licensed by Temperature Sensitive Solutions Systems Sweden AB,
reg. no. 556278-0816, Sweden, ("TSS"), and may not be used, licensed, assigned, transferred, reproduced, copied,
disclosed, disseminated, modified or amended in any way not expressly and specifically granted by TSS in writing.
TSS and TSS' suppliers reserves any and all rights not expressly granted to you in writing, including the right to take
any and all actions deemed appropriate to safeguard its rights in and to the content of this document.
*/
import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import qs from 'query-string';
import { locationShape, historyShape } from 'tss-core-lib-common';

import HelpPage from '../pages/HelpPage';
import ContactInfoPage from '../pages/ContactInfoPage';

class HelpContainer extends Component {
  static contextTypes = {};

  static propTypes = {
    intl: intlShape.isRequired,
    location: locationShape.isRequired, // eslint-disable-line
    history: historyShape.isRequired, // eslint-disable-line
  };

  static defaultProps = {};

  render() {
    const query = qs.parse( this.props.location.search );
    const tvnId = query.tvnId ? query.tvnId.toLowerCase() : null;
    const contact = query.contact ? query.contact : null;
    if ( contact ) {
      return <ContactInfoPage tvnId={ tvnId } intl={ this.props.intl } location={ this.props.location } history={ this.props.history } />;
    }
    return <HelpPage tvnId={ tvnId } history={ this.props.history } />;
  }
}

export default injectIntl( HelpContainer );



// WEBPACK FOOTER //
// ./src/containers/HelpContainer.js